export const CompanyTypes = {
    GET_COMPANY: "GET_COMPANY",
    CLEAR_COMPANY : "CLEAR_COMPANY",
    UPDATE_COMPANY : "UPDATE_COMPANY",
    EDIT_COMPANY : "EDIT_COMPANY",
}